// VER UN DOCUMENTO DENTRO DE LA APP NATIVA, desde cualquier pantalla (27-sep-2026).
//
// Dentro de la app del iPhone o de Android (Capacitor) NO HAY PESTAÑAS: todo lo que es de biango.app se carga dentro de
// la propia app, así que «abrir en otra pestaña» pone el documento EN LUGAR de la aplicación, sin barra ni botón de
// atrás, y hay que matarla para salir. El dueño lo vio con los PDF que llegan por WhatsApp. Ahí el documento se enseña en
// el visor de la propia app (components/VisorDocumento), montado UNA vez para toda la aplicación
// (components/VisorDocumentoGlobal, en App.jsx), que se cierra con la X o con el atrás del sistema.
//
// Se habla con él por un evento de la ventana, y no por un contexto de React, porque quien lo necesita es
// utils/abrirArchivo, que no es un componente y lo llaman decenas de pantallas.
export const EVENTO_VER_DOCUMENTO = 'biango:ver-documento'

// ¿Estamos dentro de la app nativa? En un navegador (también el del iPhone) no: allí las pestañas sí existen.
export function enLaAppNativa(ventana) {
  const w = ventana || (typeof window !== 'undefined' ? window : null)
  return !!(w && w.Capacitor && typeof w.Capacitor.isNativePlatform === 'function' && w.Capacitor.isNativePlatform())
}

// Pide al visor global que enseñe este documento. Devuelve false si no hay ventana a la que pedírselo.
export function verDocumentoEnLaApp({ blob, nombre, mime } = {}, ventana) {
  const w = ventana || (typeof window !== 'undefined' ? window : null)
  if (!w || typeof w.dispatchEvent !== 'function' || !blob) return false
  const Evento = w.CustomEvent || (typeof CustomEvent !== 'undefined' ? CustomEvent : null)
  if (!Evento) return false
  w.dispatchEvent(new Evento(EVENTO_VER_DOCUMENTO, { detail: { blob, nombre: nombre || 'documento', mime: mime || (blob && blob.type) || '' } }))
  return true
}
